$(document).ready(function () {

    $("#contact-us-form").on('submit', function (e) {
        e.preventDefault()
        let data = new FormData(this)

        $.ajax({
            url: 'contact_us',
            type: "post",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                if (data.status == "success") {
                    $('#contact-us-form').trigger("reset");
                    alertSuccess(data.msj)
                } else {
                    alertError(data.msj)
                }
            },
            error: function (jqXHR, xhr, status,) {
                if (jqXHR['status'] == 422) {

                    let errors = "<ul class=''>";
                    let items = "";

                    $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                        items = items + "<li class='' style='text-align:left'>" + value + "</li>";
                    });

                    errors = errors + items + "</ul>";
                    let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                        + errors
                        + "</div></div></div>";

                    swal.fire({
                        icon: 'error',
                        confirmButtonColor: "#eb0c0c",
                        title: 'Advertencia',
                        html: view,
                    })
                } else {
                    alert('Ocurrió un problema')
                }
            }
        })


    });
});
